<template>
  <div class="app-container">
    <BjRouteTabs :route-list="STOCK_DISTRIBUTION_ROUTE_LIST" />
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
          <el-col :span="4">
            <el-form-item :label="$t('goodsPage.skuCode')" prop="skuCode">
              <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsPage.skuCode')" clearable. @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('BusinessStockDistributionRatio.header.supportWarehouseCode')" prop="supportWarehouseCode">
              <BjInput v-model="queryParams.supportWarehouseCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessStockDistributionRatio.header.supportWarehouseCode')" clearable. @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('BusinessStockDistributionRatio.header.supportWarehouseName')" prop="supportWarehouseName">
              <BjInput v-model="queryParams.supportWarehouseName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessStockDistributionRatio.header.supportWarehouseName')" clearable. @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('goodsPage.categoryName')" prop="categoryId">
              <BjGoodsTypeTreeSelect v-model="queryParams.categoryId" :placeholder="$t('goodsPage.categoryName')"/>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('BusinessStockDistributionRatio.header.receiveWarehouseCode')" prop="receiveWarehouseCode">
              <BjInput v-model="queryParams.receiveWarehouseCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessStockDistributionRatio.header.receiveWarehouseCode')" clearable. @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('BusinessStockDistributionRatio.header.receiveWarehouseName')" prop="receiveWarehouseName">
              <BjInput v-model="queryParams.receiveWarehouseName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessStockDistributionRatio.header.receiveWarehouseName')" clearable. @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">  </el-col> -->
          <!-- <el-col :span="8">  </el-col> -->
      </template>

      <template v-slot:tableOperation>
        <el-col>
          <el-button v-permission:BusinessStockDistributionRatioAddSku type="primary" @click="onAddSku">{{ $t('BusinessStockDistributionRatio.commodityDistribution') }}</el-button>
          <el-button v-permission:BusinessStockDistributionRatioAddWarehouse type="primary" @click="onAddWarehouse">{{ $t('BusinessStockDistributionRatio.batchAllocation') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <span v-else-if="col.prop === 'code'" class="link" @click="onView(scope.row)">
                {{ scope.row[col.prop] }}
              </span>
              <template v-else-if="col.prop === 'status'">
                {{ $t(STOCK_DISTRIBUTION_PLAN_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="['supportTypeCode', 'receiveTypeCode'].bjIncludes(col.prop)">
                {{ $store.state.values.STOCK_WAREHOUSE_TYPE.bjGet(scope.row[col.prop]) }}
              </template>

              <template v-else-if="['warehouseStructuralQty', 'qty'].bjIncludes(col.prop)">
                {{ scope.row[col.prop] }} %
              </template>

              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="scope">
              <el-button v-permission:BusinessStockDistributionRatioEdit type="text" @click="onView(scope.row)">{{ $t('viewText') }}</el-button>
              <el-button v-permission:BusinessStockDistributionRatioView type="text" class="edit-btn" @click="onEdit(scope.row)">{{ $t('editText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <!-- <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" /> -->
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi } from '@/api';
// import DataForm from './components/DataForm.vue';
import {
  STOCK_DISTRIBUTION_ROUTE_LIST,
  STOCK_DISTRIBUTION_PLAN_STATUS_LIST,
} from '@/utils/constants';
export default {
  name: 'BusinessStockDistributionRatioIndex',
  components: {
    // DataForm,
  },
  mixins: [pageMiXin],

  data() {
    return {
      STOCK_DISTRIBUTION_ROUTE_LIST,
      STOCK_DISTRIBUTION_PLAN_STATUS_LIST,
      queryApi: stockApi.getDistributeSpacesRatio,
      // 查询参数
      queryParams: {
        categoryId: null,
        receiveWarehouseCode: null,
        receiveWarehouseName: null,
        skuCode: null,
        spuCode: null,
        spuName: null,
        supportWarehouseCode: null,
        supportWarehouseName: null,
      },

      labelList: [
        { label: 'BusinessStockDistributionRatio.table.categoryName', prop: 'categoryName', isCheck: true, disabled: false, width: 135 },
        { label: 'BusinessStockDistributionRatio.table.skuCode', prop: 'skuCode', isCheck: true, disabled: false, width: 150 },
        { label: 'BusinessStockDistributionRatio.table.supportTypeCode', prop: 'supportTypeCode', isCheck: true, disabled: false, width: 180 },
        { label: 'BusinessStockDistributionRatio.table.supportCode', prop: 'supportCode', isCheck: true, disabled: false, width: 180 },
        { label: 'BusinessStockDistributionRatio.table.supportName', prop: 'supportName', isCheck: true, disabled: false, width: 180 },
        { label: 'BusinessStockDistributionRatio.table.warehouseStructuralQty', prop: 'warehouseStructuralQty', isCheck: true, disabled: false, width: 200 },
        { label: 'BusinessStockDistributionRatio.table.categoryName', prop: 'qty', isCheck: true, disabled: false, width: 160 },
        { label: 'BusinessStockDistributionRatio.table.receiveTypeCode', prop: 'receiveTypeCode', isCheck: true, disabled: false, width: 200 },
        { label: 'BusinessStockDistributionRatio.table.receiveCode', prop: 'receiveCode', isCheck: true, disabled: false, width: 200 },
        { label: 'BusinessStockDistributionRatio.table.receiveName', prop: 'receiveName', isCheck: true, disabled: false, width: 200 },
        { label: 'BusinessStockDistributionRatio.table.lastUpdateName', prop: 'lastUpdateName', isCheck: true, disabled: false, width: 135 },
        { label: 'BusinessStockDistributionRatio.table.lastUpdateDate', prop: 'lastUpdateDate', isCheck: true, disabled: false, width: 135 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129 },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.$store.dispatch('values/getValueList', 'STOCK.WAREHOUSE_TYPE');
  },
  methods: {
    /** 添加 */
    onAddSku() {
      this.$toPage('BusinessStockDistributionRatioAddSku');
    },
    /** 添加 */
    onAddWarehouse() {
      this.$toPage('BusinessStockDistributionRatioAddWarehouse');
    },
    /** 编辑操作 */
    onEdit(row) {
      this.$toPage('BusinessStockDistributionRatioEdit', { id: row.id });
    },
    /** 查看 */
    onView(row) {
      this.$toPage('BusinessStockDistributionRatioView', { id: row.id });
    },
  },
};
</script>
<style lang="scss" scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
</style>
